import { render } from "./management.cattle.io.oidcclient.vue?vue&type=template&id=f2c91e74&scoped=true&ts=true"
import script from "./management.cattle.io.oidcclient.vue?vue&type=script&lang=ts"
export * from "./management.cattle.io.oidcclient.vue?vue&type=script&lang=ts"

import "./management.cattle.io.oidcclient.vue?vue&type=style&index=0&id=f2c91e74&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2c91e74"]])

export default __exports__